import { useState } from 'react';
import { markTutorialSeen, messagesFor } from '../../i18n';
import { useAppStore } from '../../state/store';
import { Modal } from '../components/controls';

export function TutorialDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const locale = useAppStore((state) => state.locale);
  const t = messagesFor(locale);
  const steps = t.tutorialSteps;
  const [index, setIndex] = useState(0);
  const step = steps[index] ?? steps[0];
  const last = index >= steps.length - 1;

  const finish = () => {
    markTutorialSeen();
    onClose();
  };

  return (
    <Modal
      open={open}
      title={t.tutorialTitle}
      onClose={finish}
      className="dialog--tutorial"
      footer={
        <>
          <button type="button" className="button" onClick={finish}>
            {t.skip}
          </button>
          <div className="tutorial__footer-nav">
            <button
              type="button"
              className="button"
              disabled={index === 0}
              onClick={() => setIndex((value) => Math.max(0, value - 1))}
            >
              {t.back}
            </button>
            {last ? (
              <button type="button" className="button button--primary" onClick={finish}>
                {t.done}
              </button>
            ) : (
              <button
                type="button"
                className="button button--primary"
                onClick={() => setIndex((value) => Math.min(steps.length - 1, value + 1))}
              >
                {t.next}
              </button>
            )}
          </div>
        </>
      }
    >
      <p className="tutorial__progress">
        {index + 1} / {steps.length}
      </p>
      <h3 className="tutorial__step-title">{step?.title}</h3>
      <p className="tutorial__step-body">{step?.body}</p>
      <div className="tutorial__dots" aria-hidden>
        {steps.map((_, dot) => (
          <span
            key={dot}
            className={`tutorial__dot${dot === index ? ' tutorial__dot--active' : ''}`}
          />
        ))}
      </div>
    </Modal>
  );
}
